<div>
    <a class="course-item" (click)="goToPage()">
        <div class="media" [ngStyle]="{ 'background-image': (courseImage$ | async) ? 'url(\'' + (courseImage$ | async) + '\')' : '' }">
            <figure *ngIf="courseImage$ | async as courseImage">
                <da-progressive-image
                    [options]="{
                        alt: alt,
                        aspectRatios: [
                            {
                                breakpoint: 360,
                                width: 480,
                                height: 320,
                                akamaiImage: courseImage
                            },
                            {
                                breakpoint: 480,
                                width: 780,
                                height: 520,
                                akamaiImage: courseImage
                            },
                            {
                                breakpoint: 768,
                                width: 480,
                                height: 320,
                                akamaiImage: courseImage
                            },
                            {
                                breakpoint: 960,
                                width: 380,
                                height: 253,
                                akamaiImage: courseImage
                            },
                            {
                                breakpoint: 1120,
                                width: 480,
                                height: 320,
                                akamaiImage: courseImage
                            }
                        ]
                    }"
                ></da-progressive-image>
            </figure>
        </div>
        <div class="inner-content inner-item">
            <div class="content-card">
                <div class="content-lg" *ngIf="course">
                    {{ course.name }}
                    <!-- <p *ngIf="!course.training.descriptionShort">&nbsp;</p> -->
                </div>
                <!-- <div class="details details-quick">
                <div class="inner-wrapper">
                    <div class="duration"></div>
                    <div class="wrapper" *ngIf="!course.url && course.isProduct" [innerHTML]="'courses.online' | translate"></div>
                    <div class="wrapper" *ngIf="!course.url && !course.isProduct" [innerHTML]="'courses.presence' | translate"></div>
                </div>
            </div> -->
            </div>
        </div>
    </a>
</div>
